(function () {
  'use strict';
  var root = document.querySelector('.elyone-product-page');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Gallery */
  var mainImg = root.querySelector('[data-elyone-main-image]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-elyone-thumb]'));
  var galleryIndex = 0;

  function showThumb(i) {
    if (!thumbs.length) return;
    galleryIndex = (i + thumbs.length) % thumbs.length;
    thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === galleryIndex ? 'true' : 'false'); });
    if (mainImg) mainImg.src = thumbs[galleryIndex].getAttribute('data-full');
  }
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { showThumb(i); });
  });
  var galleryPrev = root.querySelector('[data-elyone-gallery-prev]');
  var galleryNext = root.querySelector('[data-elyone-gallery-next]');
  if (galleryPrev) galleryPrev.addEventListener('click', function () { showThumb(galleryIndex - 1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { showThumb(galleryIndex + 1); });

  /* Reveal on scroll */
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    root.querySelectorAll('.elyone-reveal').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.elyone-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* FAQ */
  root.querySelectorAll('.elyone-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.style.maxHeight = expanded ? '0px' : answer.scrollHeight + 'px';
    });
  });

  /* Variant selection */
  var variantCards = root.querySelectorAll('[data-elyone-variant]');
  var variantInput = root.querySelector('[data-elyone-variant-id]');
  var addBtn = root.querySelector('[data-elyone-add-to-cart]');
  var priceNow = root.querySelector('[data-elyone-price-now]');
  var stickyPrice = root.querySelector('[data-elyone-sticky-price]');

  function selectVariant(card) {
    variantCards.forEach(function (c) { c.setAttribute('data-selected', 'false'); });
    card.setAttribute('data-selected', 'true');
    var id = card.getAttribute('data-variant-id');
    var price = card.getAttribute('data-price-label');
    var cta = card.getAttribute('data-cta-label');
    if (variantInput) variantInput.value = id;
    if (priceNow) priceNow.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (addBtn && cta) addBtn.textContent = cta;
  }
  variantCards.forEach(function (card) {
    card.addEventListener('click', function () { selectVariant(card); });
  });

  /* ---- Cart drawer integration helpers (Horizon theme) ---- */
  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function updateCartBubble(itemCount) {
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
      el.textContent = itemCount < 100 ? String(itemCount) : '';
      el.classList.toggle('hidden', itemCount === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', itemCount === 0);
    });
  }

  function refreshCartDrawerSection() {
    return fetch(shopifyRoot() + '?section_id=cart-drawer-section')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('#shopify-section-cart-drawer-section') || temp.firstElementChild;
        if (fresh) wrapper.replaceWith(fresh);
      });
  }

  /* Add to cart (AJAX, with Horizon cart-drawer + cart-bubble sync) */
  function addToCart(button) {
    if (!variantInput || !variantInput.value) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    fetch(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantInput.value, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { return Promise.reject(err); }); }
        return r.json();
      })
      .then(function () { return refreshCartDrawerSection(); })
      .then(function () { return fetch(shopifyRoot() + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          button.textContent = original;
        } else {
          button.textContent = 'Ajouté ✓';
          setTimeout(function () { button.textContent = original; }, 2000);
        }
      })
      .catch(function () {
        button.textContent = 'Réessayer';
        setTimeout(function () { button.textContent = original; }, 2000);
      })
      .finally(function () { button.disabled = false; });
  }
  root.querySelectorAll('[data-elyone-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(btn); });
  });

  /* Sticky mobile bar: show once hero buybox scrolls out of view */
  var sticky = root.querySelector('[data-elyone-sticky]');
  var heroAnchor = root.querySelector('[data-elyone-hero]');
  if (sticky && heroAnchor && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) sticky.classList.remove('is-visible');
        else sticky.classList.add('is-visible');
      });
    }, { threshold: 0 });
    obs.observe(heroAnchor);
  }

  /* Smooth scroll to buybox */
  root.querySelectorAll('[data-elyone-scroll-to]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('data-elyone-scroll-to'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }
    });
  });
})();
